import { ButtonIcon, Link, Skeleton } from 'ui/components/primitives';
import { styled, theme, utils } from 'ui/theme';

export const Hamburger = {
  Icon: styled.svg`
    color: ${theme.colors.action.navigation.standard.static};
    width: 24px;
    height: 24px;

    path {
      fill: ${theme.colors.action.navigation.standard.static};
    }
  `,

  Menu: styled(ButtonIcon)`
    ${utils.flex.center};
    background: transparent;
    color: currentColor;
    flex-direction: column;
    font-size: ${theme.fontSizes.md};
    height: ${theme.space[13]};
    padding: ${theme.space[1]};
    width: ${theme.space[12]};
  `,
};

export const Cart = {
  Component: styled(ButtonIcon)`
    grid-gap: ${theme.space[2]};
    width: 106px;
    max-width: 106px;
    min-width: 106px;
    height: 48px;
    line-height: inherit;

    span {
      color: ${theme.colors.build.lightLight};
    }

    & svg {
      color: ${theme.colors.build.lightLight};
      max-width: 16px;
      min-width: 16px;
    }
  `,

  Counter: styled.span`
    ${utils.flex.center};
    background-color: ${theme.colors.action.conversion.highlight};
    border-radius: ${theme.radii.pill};
    color: ${theme.colors.build.lightDark1};
    font-size: ${theme.fontSizes.xxs};
    height: ${theme.sizes[4]};
    line-height: 0;
    padding: calc(${theme.space[1]} / 2);
    position: absolute;
    right: ${theme.space[2]};
    top: ${theme.space[1]};
    width: ${theme.sizes[4]};
  `,
};

export const HeaderLogo = styled(Link)`
  align-items: center;
  display: flex;
  height: ${theme.sizes[6]};
  text-align: center;
  width: max-content;

  ${utils.media.min('m')`
    height: ${theme.sizes[8]};
  `}
`;

export const HeaderLogoSkeleton = styled(Skeleton)`
  height: ${theme.sizes[6]};
  width: 176px;

  ${utils.media.max('l')`
    width: 120px;
    height: 33px;
  `}
`;

export const HeaderLogoButton = styled(ButtonIcon)`
  height: ${theme.sizes[6]};
  text-align: center;
  width: max-content;

  ${utils.media.min('m')`
    height: ${theme.sizes[8]};
  `}
`;

export const HeaderLogoWrapper = styled('div')`
  display: flex;
  justify-content: center;
  padding: ${theme.sizes[6]} 0;
  width: 100%;
`;

export const Logout = {
  Button: styled(ButtonIcon)`
    border: ${theme.borderWidths.hairline} solid
      ${theme.colors.action.navigation.standard.highlight};
    font-size: ${theme.fontSizes.md};
    height: ${theme.sizes[8]};
    margin: 0 auto;
    max-width: 142px;
    flex-direction: row;

    > svg {
      color: ${theme.colors.action.navigation.standard.highlight};
      width: ${theme.sizes[3]};
    }
  `,
};
